export default "__VITE_ASSET__Bxm0woCk__"